import { LeafTabItem } from "./tab-item.component.js";
customElements.define("leaf-tab-item", LeafTabItem);
export {
  LeafTabItem
};
//# sourceMappingURL=tab-item.js.map
